var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57101 21.2158C3.70152 20.7473 3.1106 19.8283 3.1106 18.7714V10.4467C3.1106 8.91414 4.35297 7.67177 5.88551 7.67177H10.933L18.4859 1.37766C18.9846 0.962085 19.6132 0.734497 20.2624 0.734497H21.1475C22.6801 0.734497 23.9224 1.97687 23.9224 3.50941V4.98587L4.57101 21.2158ZM23.9224 12.2292V25.7087C23.9224 27.2412 22.6801 28.4836 21.1475 28.4836H20.2624C19.6132 28.4836 18.9846 28.256 18.4859 27.8404L11.8762 22.3323L23.9224 12.2292ZM2.76955 28.1592C2.18244 28.6516 1.30731 28.5748 0.814903 27.9877C0.322493 27.4006 0.399265 26.5255 0.986379 26.0331L25.8057 5.21716C26.3929 4.72475 27.268 4.80153 27.7604 5.38864C28.2528 5.97575 28.176 6.85088 27.5889 7.34329L2.76955 28.1592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.87394f31aef3dbaad5593db4164821ba.svg";
export { ForwardRef as ReactComponent };